import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { PricingService } from '../../services/pricing.service';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'lib-pricing',
  templateUrl: './pricing.html'
})
export class PricingComponent implements OnInit, OnDestroy {
    @Input() public defaultFormData: string[];
    public pricingData:any[] = [];
    public pricingTotal = 0;
    @Input() public isVisible = false;
    @Input() public isPersonnel = false;
    @Input() public decisionKey:string;
    public isPricingZero = false;
    public confirm:any= {'isLoading': false};
    public loading = true;
    @Output() public submitEvent = new EventEmitter<any>()
    public subscription: Subscription;

    constructor(private messageService: MessageService, private pricingService: PricingService) {
      this.subscription = this.messageService.getPricing().subscribe(decisionObj => {
        this.getPricingDetails(decisionObj);
      });
    }

    ngOnInit() :void{
      if (!_.isEmpty(this.defaultFormData)) {
        this.getPricingDetails(this.defaultFormData);
      }

    }

    ngOnDestroy():void{
      this.subscription.unsubscribe();
    }

    getPricingDetails(decisionObj:any):void{
      this.loading = true;
      this.pricingService.getPricing(decisionObj, this.decisionKey).subscribe((response:any) => {
        this.loading = false;
        this.pricingData = response.resultList;
        let total = 0;
        _.forEach(this.pricingData, (pricing) => {
          total += (typeof pricing.pricingValue === 'string') ? parseFloat(pricing.pricingValue) : pricing.pricingValue;
        });
        if(total < 1){
          this.isPricingZero = true;
          return;
        }
        this.pricingTotal = total;
        this.pricingData = [...this.pricingData];
        if(this.isPersonnel){
          this.submitEvent.emit(this.pricingData);
        }
      },
      // (error)=>{
      //   this.loading = false;}
      );
    }

    handleOk():void {
      this.confirm.isLoading = true;
      this.confirm['pricingData'] =  this.pricingData;
      this.submitEvent.emit(this.confirm);
    }

    handleCancel():void {
      this.isVisible = false;
      this.submitEvent.emit(false);
    }
}
